export type Honbu = '1honbu' | '2honbu';

export const HONBU_LABEL: Record<Honbu, string> = {
  '1honbu': '1本部',
  '2honbu': '2本部',
};
